import React, { useCallback } from 'react'
import { Marker } from 'react-leaflet';
import { setAnchorPosition, setSelectedRoom } from '../../../store/MapDisplaySlice';
import { useDispatch, useSelector } from 'react-redux';
import { getMeetingsByRoomId } from '../../../store/MapDisplayThunks';
import RoomMenu from './RoomMenu/RoomMenu';
import "./Room.css"
import L from "leaflet";
import { setOpenedUpcomingMeetingId,setOpenedOngoingMeetingId } from '../../../store/RoomMenu/RoomMenuSlice';
export default function Room({ room, index, mapConfig, markerOpacity, lockIconUrl, mapRef, zoomLevel, isLocked, hasEvent }) {
    const dispatch = useDispatch();
    const { anchorPosition, selectedRoom } = useSelector((state) => state.MapDisplay);
    const { localAvatar } = useSelector((state) => state.auth);
        const handleOpenMenu = async (e, room) => {
            try {
                if (!room || room.room_id == null || room.map_id == null || localAvatar?.chair_id == null || localAvatar?.id == null) {
                console.error("Missing required data");
                return;
                }
                dispatch(setSelectedRoom(room));
                await dispatch(getMeetingsByRoomId( {params:[{roomId:room.room_id }] }));
                const { clientX, clientY } = e.originalEvent;

                dispatch(setAnchorPosition({
                top: clientY + 10,
                left: clientX + 10,
                }));
            } catch (error) {
                console.error("Error opening menu:", error);
            }
        };
       const handleCloseMenu = () => {
       dispatch(setOpenedOngoingMeetingId(null));
       dispatch(setOpenedUpcomingMeetingId(null));
       dispatch(setAnchorPosition(null));
       };

        const renderRoom = useCallback(()=>  {
                        const scaleFactor = zoomLevel / mapConfig?.maxZoom;
                        const htmlContent = isLocked
                            ? `
                            <div class='custom-div-icon' style='
                                transform: scale(${scaleFactor}) translate(-50%, -50%);
                                transform-origin: center;
                                ${( mapConfig?.visibilityZoomThreshold && zoomLevel <= mapConfig?.visibilityZoomThreshold && room?.chair_count < 4) ? 'display: none;' : ""}
                                '>
                                <div class='room-label' style='opacity: ${markerOpacity};'>
                                <span
                                    class="room-title"
                                    title="${room.label}"
                                    data-tour-room="${room.label.toLowerCase().replace(/\s+/g,"-")}"
                                >
                                    ${room.label}
                                </span>${
                                hasEvent
                                    ? `
                                <div class='calendar-icon'>
                                <span class="material-symbols-outlined" style="font-size: 1.5625rem; color: #77DD48;">event</span>
                                </div>
                            `
                                    : ""
                                }

                                <img src='${lockIconUrl}' />
                                </div>
                            </div>
                            `
                                            : `
                            <div class='custom-div-icon' style='
                                transform: scale(${scaleFactor}) translate(-50%, -50%);
                                transform-origin: center;
                                ${( mapConfig?.visibilityZoomThreshold && zoomLevel <= mapConfig?.visibilityZoomThreshold && room?.chair_count < 4) ? 'display: none;' : ""}

                                '>
                                <div class='room-label' style='opacity: ${markerOpacity};'>
                                                           <span
                                    class='room-title'
                                    title='${room.label}'
                                    data-tour-room='${room.label.toLowerCase().replace(/\s+/g,"-")}'
                                    >
                                    ${room.label}
                                    </span>${

                                    hasEvent
                                        ? `
                                    <div class='calendar-icon'>
                                    <span class="material-symbols-outlined" style="font-size: 1.5625rem; color: #77DD48;">event</span>
                                    </div>
                                `
                                        : ""
                                }

                                </div>
                            </div>
                            `;
                        const customIcon = L.divIcon({
                            className: "custom-div-icon",
                            html: htmlContent,
                            iconSize: [0, 0], // Taille fixe (gérée par le scale)
                            iconAnchor: [15, 35], // Centre l'ancre (50% de la taille fixe)
                        });

                        return (
                            <div key={index}>
                                
                                <Marker
                                    key={index}
                                    position={room.position}
                                    icon={customIcon}
                                    opacity={markerOpacity}
                                    eventHandlers={{
                                        click: async (e) => {
                                            await handleOpenMenu(e, room);
                                        },
                                    }}
                                >
                                    {anchorPosition && room.room_id === selectedRoom?.room_id
                                    && (
                                        <RoomMenu
                                            handleCloseMenu={handleCloseMenu}
                                            isGuestUser={localAvatar?.is_guest === 1}
                                        /> 
                                    )}
                            
                                </Marker>
                                
                            </div>
                        );
                    }, [
                        anchorPosition,
                        hasEvent,
                        index,
                        isLocked,
                        localAvatar?.is_guest,
                        localAvatar?.chair_id,
                        localAvatar?.id,
                        room.label,
                        room.position,
                        room.room_id,
                        selectedRoom?.room_id,
                        zoomLevel,
                        markerOpacity
                    ]);

  return (
    <>
        {(() => renderRoom(room, index))()}
    </>
  )

}